<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="paraa"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="paraa"><span class="smallcaps">BLOOD VINES</span>. Copyright © 2010 by Erica Spindler. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="para"> </p>
<p class="paraa"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="para"> </p>
<p class="paraa">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="paraa">Spindler, Erica, 1957–</p>
<p class="indent-paraa">Blood vines / Erica Spindler. — 1st ed.</p>
<p class="indent-paraa">        p. cm.</p>
<p class="indent-paraa">ISBN 978-0-312-36392-5</p>
<p class="indent-paraa">1. Single women—Fiction. 2. Brothers—Crimes against—Fiction. 3. Human sacrifice—Fiction. 4. Vintners—California—Sonoma Valley—Fiction. 5. Sonoma County (Calif.)—Fiction. 6. Domestic fiction. 7. Identity (Psychology)—Fiction.</p>
<p class="paraa">I. Title.</p>
<p class="indent-paraa">PS3569.P5436B58 2010</p>
<p class="indent-paraa">813'.54—dc22</p>
<p class="right-paraa">2009040234</p>
<p class="para"> </p>
<p class="paraa">First Edition: March 2010</p>
<p class="para"> </p>
<p class="paraa">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?514329e6